import { QueryClient } from '@tanstack/react-query';
import { ApiClientError } from './apiClient.js';

/**
 * One client, tuned once. Per §5.3 each dashboard tile owns its own query key and
 * fetches independently, so these defaults are the difference between a dashboard that
 * feels instant and one that re-fetches everything on every focus change.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // A 4xx is a contract problem; retrying it just burns the user's time.
        if (error instanceof ApiClientError && error.status < 500) return false;
        return failureCount < 2;
      },
    },
  },
});
